import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import { conditionFormChecker, putField } from "../../../utils/form";
import { createFieldRegister1, createFieldRegisterOfficerInfo, createFieldRegisterUserInfo } from "../../account/register/register.section";

const AttachmentInlineList = defineAsyncComponent(() => import("../../../components/attachment/AttachmentInlineList"));

export const createField = ({ props, data, key = "", isLoading }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            {
                visible: () => model.refStatus && model.refStatus.key === "waitApproveCenter",
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <div class="text-bold text-16 text-center text-primary">{model.refStatus?.value}</div>
            },
            ...createFieldRegister1({ props, data, key: `${key}refUserTemp`, isLoading }),
            ...createFieldRegisterOfficerInfo({ props, data, key: `${key}refUserTemp`, isLoading }),
            ...createFieldRegisterUserInfo({ props, data, key: `${key}refUserTemp`, isLoading }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}refUserTemp.attachments`,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "AttachmentInlineList" } })
                    );
                    return <AttachmentInlineList {...componentProp}></AttachmentInlineList>;
                }
            }
        ]
    });
};
